import { prepareDataForDropdown } from '../../../../../components/organisms/Filters/utils';
import { Field_Keys } from '../../../../../constants';
import useFetchData from '../../../../../hooks/fetchHook';
import { DC } from '../controllers/variables';

export const useGetFilters = ({ ignore }) => {
  const [{ data, isLoading = true, isError, error }, _, refetchFilters] =
    useFetchData('office_knowledge_base/filters', {
      formatter,
      ignore,
    });

  return {
    data,
    isLoading,
    isError,
    error,
    refetchFilters,
  };
};

export const formatter = data => {
  const { categories, adding_clients, brands } = data;

  const newOps = {};

  newOps[DC.PRODUCT_CATEGORY] = prepareDataForDropdown(
    categories,
    Field_Keys.CATEGORY.FULL,
    Field_Keys.CATEGORY.SUBCATEGORY_ID
  );

  newOps[DC.ADDED_BY] = prepareDataForDropdown(
    adding_clients,
    Field_Keys.INSTRUCTION.CREATING_USER_DISPLAY_NAME,
    Field_Keys.INSTRUCTION.CREATING_USER_CLIENT_ID,
    {
      sectionTitle: 'Others',
    }
  );

  newOps[DC.BRANDS] = prepareDataForDropdown(
    brands,
    Field_Keys.INSTRUCTION.BRAND_NAME,
    Field_Keys.INSTRUCTION.BRAND_ID
  );

  return newOps;
};
